import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip, Alert, Typography } from "@mui/material";
import * as wjGrid from "@grapecity/wijmo.react.grid";
import * as wjCore from "@grapecity/wijmo";
import { Selector } from "@grapecity/wijmo.grid.selector";
import { useRef, useState } from "react";
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";
import './apartmentSelectionDialog.css';
import { Warning } from "@mui/icons-material";

const ApartmentSelectionDialog = ({
    open,
    apartments,
    tempSelected,
    setTempSelected,
    onConfirm,
    onClose,
    childGender,
    childAge
}) => {
    const gridRef = useRef(null)
    const selectorRef = useRef(null);
    const [selectedApartment, setSelectedApartment] = useState(null);



    const formatCharacteristics = (cc) => {
        if (!cc || cc.length === 0) return "-";
        return cc.map((c) => `${c.gender} (${c.age})`).join(", ");
    };

    return (
        <Dialog
            open={open}
            maxWidth="xl"
            fullWidth
            onClose={onClose}
        >
            <DialogTitle variant='h4'>Επιλογή Διαμερίσματος ΜΗΔ για {childGender} - {childAge} ετών</DialogTitle>

            <DialogContent dividers sx={{ height: 600, p: 2 }}>{
                apartments?.length > 0 ?
                    <wjGrid.FlexGrid
                        frozenColumns={2}
                        itemsSource={apartments}
                        isReadOnly={true}
                        selectionMode="Row"
                        headersVisibility="Column"
                        className="apartment-selection-grid"
                        maxHeight="95%"
                        style={{ height: '95%' }}

                        initialized={(grid) => {
                            gridRef.current = grid;
                            selectorRef.current = new Selector(grid, {
                                showCheckAll: false,
                            })

                            // CHECKBOX CLICK HANDLER
                            grid.hostElement.addEventListener('mousedown', (e) => {
                                let ht = grid.hitTest(e);
                                if (ht.cellType === 1) {
                                    grid.beginUpdate();
                                    grid.selectedRows.forEach(row => row.isSelected = false);
                                    grid.endUpdate();
                                    grid.rows[ht.row].isSelected = !e.target.checked;
                                    gridRef.current.selectedApartment = grid.rows[ht.row].dataItem;
                                    if (!e.target.checked)
                                        setSelectedApartment(grid.rows[ht.row].dataItem);
                                    else setSelectedApartment(null);
                                }
                            });
                            // DOUBLE CLICK
                            grid.hostElement.addEventListener("dblclick", (e) => {
                                const ht = grid.hitTest(e);
                                if (ht.cellType === wjGrid.CellType.Cell) {
                                    onConfirm(grid.rows[ht.row].dataItem);
                                }
                            });

                            // KEYBOARD
                            // grid.hostElement.addEventListener("keydown", () => {
                            //     const item = grid.collectionView.currentItem;
                            //     if (item) setTempSelected(item);
                            // });
                        }}
                        formatItem={(s, e) => {
                            const item = s.rows[e.row]?.dataItem;



                            // ROW HIGHLIGHT
                            if (e.panel === s.cells) {
                                if (tempSelected?.id === item?.id) {
                                    e.cell.style.backgroundColor = "#e3f2fd";
                                }
                            }
                        }}
                    >
                        <FlexGridFilter />
                        <wjGrid.FlexGridColumn header="" width={50} align="center" />
                        <wjGrid.FlexGridColumn binding="name" header="Όνομα" width={460}>
                            <wjGrid.FlexGridCellTemplate cellType='Cell' template={(ctx) => {
                                const item = ctx.item;
                                return (<>
                                    {!item.hasActiveUsers &&
                                        <Tooltip title='Η ΜΗΔ δεν διαθέτει ενεργό προσωπικό!'>
                                            <Warning color='warning' fontSize='small' sx={{ mr: 1 }} />
                                        </Tooltip>}
                                    <span>{item.name}</span>
                                </>)
                            }} />
                        </wjGrid.FlexGridColumn>


                        <wjGrid.FlexGridColumn binding="capacity" header="Δυναμ." width={80} />
                        <wjGrid.FlexGridColumn binding="available" header="Διαθ." width={80} cssClass='qub-css-font-bold qub-css-bgcolor-yellow qub-css-forecolor-black' />
                        <wjGrid.FlexGridColumn binding="pendingRequests" header="Αιτήσεις" width={100} />
                        <wjGrid.FlexGridColumn binding="characteristics" header="Ήδη διαμένοντες" width={200} />
                        <wjGrid.FlexGridColumn binding="municipality" header="Δήμος" width={400} />
                        <wjGrid.FlexGridColumn binding="prefecture" header="Περιφερειακή Ενότητα" width={400} />


                    </wjGrid.FlexGrid> :
                    <Typography align='center' mt={2} mb={2} variant='h4'>Δεν βρέθηκαν διαθέσιμα διαμερίσματα!</Typography>}

            </DialogContent >

            <DialogActions>

                <Button onClick={onClose}>Κλείσιμο</Button>
                <Button variant="contained" onClick={() => onConfirm(selectedApartment)} disabled={!!!selectedApartment}>
                    Επιλογή
                </Button>
            </DialogActions>
        </Dialog >
    );
};

export default ApartmentSelectionDialog;
